export default __webpack_public_path__ + "static/media/most2.0d033ca7.jpg";